<div class="ui-g-12">

    <div class="ui-g">
        <div *ngFor="let indicator of indicators" class="ui-g-12 ui-md-3 ui-sm-6">
            <app-infobox [pointData]="indicator.pointData" [penetration]="indicator.penetration" [t]="indicator.t" [options]="indicator.options"></app-infobox>
        </div>
    </div>

    <p-dialog header="Error" [(visible)]="storeError" [width]="300" [modal]="true" [draggable]="false" [resizable]="false">
        <p>{{ selectOneError }}</p>
        <div class="ui-dialog-footer">
            <button pButton type="button" class="slim red-button" (click)="toogleErrorStoreDialog()" label="Ok"></button>
        </div>
    </p-dialog>

</div>



// WEBPACK FOOTER //
// ./src/app/views/products/products-overview/products-overview-kpi/products-overview-kpi.component.html